import React from "react";
import { useTranslation } from "react-i18next";
import "./Awards.scss";
import fit4businessLogo from "../img/F4B_Logo.png";

const Awards = () => {
  const { t } = useTranslation();

  return (
    <div className="awards-section">
      {/*<div className="section-header">*/}
      {/*  <h2 className="awards-title">{t("Awards")}</h2>*/}
      {/*</div>*/}
      <div className="award-container" data-aos="fade-up" data-aos-delay="100">
        <div className="award-logo">
          <img src={fit4businessLogo} alt="FIT4BUSINESS Logo" />
        </div>
        <div className="award-content">
          <div className="award-header">
            <h3>FIT4BUSINESS 2024</h3>
            <span className="award-badge">{t("FirstPlace")}</span>
          </div>
          <p className="award-description">
            {t("Fit4BusinessAwardDescription")}
          </p>
          <div className="award-footer">
            <span className="award-detail">{t("December")} 2024</span>
            <span className="award-detail">Kufstein, Austria</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Awards;
